import React, { useEffect } from 'react';
import { X } from 'react-feather';
import useLayersStore from '../stores/layersStore';

const ScreenshotDisplay = () => {
  const { screenshot, setScreenshot } = useLayersStore();

  // Clean up screenshot from memory when component unmounts
  useEffect(() => {
    return () => {
      if (screenshot) {
        console.log('Cleaning up screenshot from memory');
        setScreenshot(null);
      }
    };
  }, [screenshot, setScreenshot]);

  const handleClose = () => {
    console.log('Closing screenshot display');
    setScreenshot(null);
  };

  if (!screenshot) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center">
      <div className="relative bg-white rounded-lg shadow-xl max-w-4xl max-h-[90vh] overflow-hidden">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 z-10 flex items-center gap-2 px-3 py-2 bg-white/90 backdrop-blur-sm rounded-md shadow-md hover:bg-white transition-colors text-sm font-medium"
        >
          <X size={14} />
          Close
        </button>
        
        {/* Screenshot image */}
        <img
          src={screenshot}
          alt="3D Model Screenshot"
          className="w-full h-full object-contain"
          style={{ maxHeight: '90vh' }}
        />
        
        {/* Download button */}
        <div className="absolute bottom-4 right-4">
          <button
            onClick={() => {
              const link = document.createElement('a');
              link.download = `3d-model-screenshot-${new Date().toISOString().slice(0, 19)}.png`;
              link.href = screenshot;
              link.click();
            }}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md shadow-md hover:bg-blue-700 transition-colors text-sm font-medium"
          >
            Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScreenshotDisplay;
